import {all, call, fork, put, takeEvery} from "redux-saga/effects";
import {getMeshNetworks} from "apollo/queries/getMeshNetworks";
import {describeJobExecutionQuery} from "apollo/queries/describeJobExecution";
import {updateMeshNetworkMutation} from "apollo/mutations/updateMeshNetwork";
import {createMeshNetworkMutation} from "apollo/mutations/createMeshNetwork";
import {deleteMeshNetworkMutation} from "apollo/mutations/deleteMeshNetwork";
import {updateMeshApplicationMutation} from "apollo/mutations/updateMeshApplication";
import {createMeshApplicationMutation} from "apollo/mutations/createMeshApplication";
import {deleteMeshApplicationMutation} from "apollo/mutations/deleteMeshApplication";
import {meshDiscoverUnprovisionedMutation} from "apollo/mutations/meshDiscoverUnprovisioned";
import {meshProvisionMutation} from "apollo/mutations/meshProvision";
import {meshGetMutation} from "apollo/mutations/meshGet";
import {meshSetMutation} from "apollo/mutations/meshSet";
import {fetchMeshNetworksSuccess, updateMeshNetworkSuccess,
createMeshNetworkSuccess, deleteMeshNetworkSuccess,
updateMeshApplicationSuccess, createMeshApplicationSuccess,
deleteMeshApplicationSuccess, meshDiscoverUnprovisionedSuccess,
meshProvisionSuccess, meshGetSuccess, meshSetSuccess,
describeJobExecutionSuccess} from "../actions/MeshNetwork";
import {fetchError} from "../actions/Common";
import {client} from "apollo/client";

import {
  CREATEMESHNETWORK,
  UPDATEMESHNETWORK,
  DELETEMESHNETWORK,
  FETCHMESHNETWORKS,
  CREATEMESHAPPLICATION,
  UPDATEMESHAPPLICATION,
  DELETEMESHAPPLICATION,
  MESHDISCOVERUNPROVISIONED,
  MESHPROVISION,
  MESHGET,
  MESHSET,
  DESCRIBEJOBEXECUTION
} from "constants/ActionTypes";

const getMeshNetworksRequest = async (applicationId) => {
  try {
    let { data, error } = await client.query({
      query: getMeshNetworks,
      variables: {
        application: applicationId
      },
      fetchPolicy: 'network-only'
    });

    console.log('data', data);
    console.log('error', error);

    if (data) {
      return Promise.resolve(data);
    } else {
      return Promise.reject(error);
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const createMeshNetworkRequest = async (input) => {
  console.log('input', input);
  let { data, error } = await client.mutate({
    mutation: createMeshNetworkMutation,
    variables: {
      input: input
    }
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const updateMeshNetworkRequest = async (input) => {
  console.log('input', input);

  let { data, error } = await client.mutate({
    mutation: updateMeshNetworkMutation,
    variables: {
      input
    }
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const deleteMeshNetworkRequest = async (input) => {
  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: deleteMeshNetworkMutation,
      variables: {
        meshNetworkId: input
      }
    });

    console.log('data', data);

    if (data.deleteMeshNetworkById.rows_deleted > 0) {
      return Promise.resolve(data);
    } else {
      return Promise.reject("Mesh network not found");
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const createMeshApplicationRequest = async (input) => {
  console.log('input', input);
  let { data, error } = await client.mutate({
    mutation: createMeshApplicationMutation,
    variables: {
      input: input
    }
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const updateMeshApplicationRequest = async (input) => {
  console.log('input', input);

  let { data, error } = await client.mutate({
    mutation: updateMeshApplicationMutation,
    variables: {
      input
    }
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const deleteMeshApplicationRequest = async (input) => {
  console.log('input', input);

  try {
    let { data, error } = await client.mutate({
      mutation: deleteMeshApplicationMutation,
      variables: {
        meshApplicationId: input
      }
    });

    console.log('data', data);

    if (data.deleteMeshApplicationById.rows_deleted > 0) {
      return Promise.resolve(data);
    } else {
      return Promise.reject("Mesh application not found");
    }
  } catch (e) {
    console.log('e', e);
    return Promise.reject(e);
  }
}

const meshDiscoverUnprovisionedRequest = async (input) => {
  console.log('input', input);

  let { data, error } = await client.mutate({
    mutation: meshDiscoverUnprovisionedMutation,
    variables: {
      input
    }
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const meshProvisionRequest = async (input) => {
  console.log('input', input);

  let { data, error } = await client.mutate({
    mutation: meshProvisionMutation,
    variables: {
      input
    }
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const meshGetRequest = async (input) => {
  console.log('input', input);

  let { data, error } = await client.mutate({
    mutation: meshGetMutation,
    variables: {
      input
    }
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const meshSetRequest = async (input) => {
  console.log('input', input);

  let { data, error } = await client.mutate({
    mutation: meshSetMutation,
    variables: {
      input
    }
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

const describeJobExecutionRequest = async (queryParams) => {
  let { data, error } = await client.query({
    query: describeJobExecutionQuery,
    variables: {
      ...queryParams
    },
    fetchPolicy: 'network-only'
  });

  if (data) {
    return Promise.resolve(data);
  } else {
    return Promise.reject(error);
  }
}

function* getMeshNetworksCall({payload}) {
  console.log('getMeshNetworksCall', payload);
  const {applicationId} = payload;

  try {
    const fetchedMeshNetworks = yield call(getMeshNetworksRequest, applicationId);
    yield put(fetchMeshNetworksSuccess(fetchedMeshNetworks, applicationId));
  } catch (error) {
    yield put(fetchError(error));
  }
}

function* createMeshNetworkCall({payload}) {

  try {
    const {createMeshNetwork} = yield call(createMeshNetworkRequest, payload);
    yield put(createMeshNetworkSuccess(createMeshNetwork));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* updateMeshNetworkCall({payload}) {
  try {
    const {updateMeshNetwork} = yield call(updateMeshNetworkRequest, payload);
    yield put(updateMeshNetworkSuccess(updateMeshNetwork));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* deleteMeshNetworkCall({payload}) {

  try {
    const deletedMeshNetwork = yield call(deleteMeshNetworkRequest, payload);
    yield put(deleteMeshNetworkSuccess(deletedMeshNetwork));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* createMeshApplicationCall({payload}) {
  try {
    const {createMeshApplication} = yield call(createMeshApplicationRequest, payload);
    yield put(createMeshApplicationSuccess(createMeshApplication));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* updateMeshApplicationCall({payload}) {
  try {
    const {updateMeshApplication} = yield call(updateMeshApplicationRequest, payload);
    yield put(updateMeshApplicationSuccess(updateMeshApplication));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* deleteMeshApplicationCall({payload}) {

  try {
    const deletedMeshApplication = yield call(deleteMeshApplicationRequest, payload);
    yield put(deleteMeshApplicationSuccess(deletedMeshApplication));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* meshDiscoverUnprovisionedCall({payload}) {
  try {
    const job = yield call(meshDiscoverUnprovisionedRequest, payload);
    yield put(meshDiscoverUnprovisionedSuccess(job));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* meshProvisionCall({payload}) {
  try {
    const job = yield call(meshProvisionRequest, payload);
    yield put(meshProvisionSuccess(job));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* meshGetCall({payload}) {
  try {
    const job = yield call(meshGetRequest, payload);
    yield put(meshGetSuccess(job));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* meshSetCall({payload}) {
  try {
    const job = yield call(meshSetRequest, payload);
    yield put(meshSetSuccess(job));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

function* describeJobExecutionCall({payload}) {
  try {
    const status = yield call(describeJobExecutionRequest, payload);
    yield put(describeJobExecutionSuccess(payload.jobId, status));
  } catch (error) {
    console.log('error', error);
    yield put(fetchError(error));
  }
}

export function* fetchMeshNetworks() {
  yield takeEvery(FETCHMESHNETWORKS, getMeshNetworksCall);
}

export function* updateMeshNetwork() {
  yield takeEvery(UPDATEMESHNETWORK, updateMeshNetworkCall);
}

export function* createMeshNetwork() {
  yield takeEvery(CREATEMESHNETWORK, createMeshNetworkCall);
}

export function* deleteMeshNetwork() {
  yield takeEvery(DELETEMESHNETWORK, deleteMeshNetworkCall);
}

export function* updateMeshApplication() {
  yield takeEvery(UPDATEMESHAPPLICATION, updateMeshApplicationCall);
}

export function* createMeshApplication() {
  yield takeEvery(CREATEMESHAPPLICATION, createMeshApplicationCall);
}

export function* deleteMeshApplication() {
  yield takeEvery(DELETEMESHAPPLICATION, deleteMeshApplicationCall);
}

export function* meshDiscoverUnprovisioned() {
  yield takeEvery(MESHDISCOVERUNPROVISIONED, meshDiscoverUnprovisionedCall);
}

export function* meshProvision() {
  yield takeEvery(MESHPROVISION, meshProvisionCall);
}

export function* meshGet() {
  yield takeEvery(MESHGET, meshGetCall);
}

export function* meshSet() {
  yield takeEvery(MESHSET, meshSetCall);
}

export function* describeJobExecution() {
  yield takeEvery(DESCRIBEJOBEXECUTION, describeJobExecutionCall);
}

export default function* rootSaga() {
  yield all([
  fork(updateMeshNetwork),
  fork(createMeshNetwork),
  fork(deleteMeshNetwork),
  fork(fetchMeshNetworks),
  fork(updateMeshApplication),
  fork(createMeshApplication),
  fork(deleteMeshApplication),
  fork(meshDiscoverUnprovisioned),
  fork(meshProvision),
  fork(meshGet),
  fork(meshSet),
  fork(describeJobExecution)]);
}
